import React from 'react';
import PhotoCard from 'components/PhotoCard';
import photo1 from 'assets/photos/1.jpg';
import photo2 from 'assets/photos/2.jpg';
import photo3 from 'assets/photos/3.jpg';
import photo4 from 'assets/photos/4.jpg';
import photo5 from 'assets/photos/5.jpg';
import './isotopCards.scss';
import './isotope-items.scss';

function IsotopeCards() {
  let cardData = [
    {
      size: 'tall',
      category: 'LIFE',
      title: 'Life is like a box of chocolate',
      description: 'You will never know what you gonna get',
      color: 'danger',
      image: photo1,
    },
    {
      size: 'wide',
      category: 'Happiness',
      title: 'If you want to be happy',
      description: 'Make yourself useful',
      color: 'info',
      image: photo3,
    },
    {
      size: 'wide-tablet',
      category: 'Meaning',
      title: 'eaning is the sense that your life',
      description: 'truly matter and have purpose',
      color: 'success',
      image: photo4,
    },
    {
      size: '',
      category: 'Study',
      title: 'I would like to live to study',
      description: 'Not study to live',
      color: 'success',
      image: photo5,
    },
    {
      size: 'wide',
      category: 'Health',
      title: 'Health is not a condition of matter',
      description: 'But of mind',
      color: 'warning',
      image: photo2,
    },
  ];
  return (
    <section className='section-cards clearfix'>
      <ul className='isotope-items' id='isotope-items'>
        {cardData.map((d, i) => (
          <li className={'item item-' + d.size} key={i}>
            <PhotoCard {...d} />
          </li>
        ))}
      </ul>
    </section>
  );
}

export default IsotopeCards;
